export default __webpack_public_path__ + "static/media/sneakerDetailBgMb.be928cd4.png";